import React, { useEffect } from 'react';
import { useAnalytics } from '@growth/use-analytics';
import { RecentSearchCardDweb } from '@growth/recent-search/Card/dweb';
import { NewCaraousel } from '@growth/carousal';
import { DwebRecentSearchAppCardBasic } from '@growth/app-banners/Banners/DwebRecentSearchAppCard';
import { useCardLoad } from '@growth/custom-hooks/useCardLoad';
import { safeParse } from '@growth/object-utils';
import { pdtPush } from '@growth/pdt-push';
import { _ as _taggedTemplateLiteralLoose } from './taggedTemplateLiteralLoose-7a042257.esm.js';
import styled from 'styled-components';
import { D as DwebHomeCardWrapper, a as DwebSectionCard } from './style-1cded105.esm.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13;
styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tpadding: 0 10px;\n\talign-items: center;\n\tmargin-bottom: 8px;\n"])));
var SearchHeader = styled.h4(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n\tfont-weight: 500;\n\tfont-size: 16px;\n\tcolor: #777777;\n\tpadding: 22px 0px 12px 22px;\n"])));
styled.ul(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\toverflow: scroll;\n\tpadding: 4px 10px;\n\tmargin-bottom: 16px;\n\t-ms-overflow-style: none; /* IE and Edge */\n\tscrollbar-width: none;\n\t&::-webkit-scrollbar {\n\t\tdisplay: none;\n\t}\n"])));
styled.li(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n\tpadding: 8px;\n\tmin-width: 180px;\n\tmax-width: 225px;\n\tbackground: #ffffff;\n\tbox-shadow: 0px 2px 4px rgba(0, 0, 0, 0.118908);\n\tborder-radius: 8px;\n\tmargin-right: 8px;\n\tflex-shrink: 0;\n"])));
styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n\twidth: 180px;\n\tdisplay: flex;\n\talign-items: center;\n\tbackground: #ffffff;\n\tposition: relative;\n\tbox-shadow: 0px 2px 4px rgba(0, 0, 0, 0.118908);\n\tborder-radius: 8px;\n\tbackground: linear-gradient(286.44deg, #ffffff 23.59%, #fff1ed 100.85%);\n\tflex-shrink: 0;\n\t&:last-child {\n\t\tmargin-right: 0;\n\t}\n"])));
styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tmargin-bottom: 10px;\n"])));
styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n"])));
styled.img(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n\twidth: 9px;\n\theight: 12px;\n"])));
styled.span(_templateObject9 || (_templateObject9 = _taggedTemplateLiteralLoose(["\n\tcolor: #777777;\n\tfont-size: 11px;\n\tline-height: 13px;\n\tpadding: 0 4px;\n"])));
styled.span(_templateObject10 || (_templateObject10 = _taggedTemplateLiteralLoose(["\n\tcolor: #777777;\n\tfont-size: 11px;\n\tline-height: 13px;\n"])));
styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\theight: 18px;\n"])));
styled.h4(_templateObject12 || (_templateObject12 = _taggedTemplateLiteralLoose(["\n\tfont-size: 12px;\n\tline-height: 14px;\n\tcolor: #141823;\n\tfont-weight: 500;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\ttext-transform: capitalize;\n\tmax-width: ", ";\n"])), function (props) {
  return props.fullwidth ? 'auto' : '88px';
});
styled.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteralLoose(["\n\tmargin-top: 10px;\n\tfont-size: 11px;\n\tline-height: 13px;\n\tcolor: #777777;\n\tpadding-right: 4px;\n\tmargin-right: 4px;\n\tborder-right: 1px solid #777777;\n\t&:last-child {\n\t\tmargin-right: 0;\n\t\tpadding-right: 0;\n\t\tborder-right: none;\n\t\toverflow: hidden;\n\t\twhite-space: nowrap;\n\t\ttext-overflow: ellipsis;\n\t}\n"])));

var RecentSearchDwebRendererHOC = function RecentSearchDwebRendererHOC(Card) {
  var RecentSearchDwebCardWithHOC = function RecentSearchDwebCardWithHOC(_ref) {
    var cardSeq = _ref.cardSeq,
      skywalkerCardData = _ref.skywalkerCardData,
      lobName = _ref.lobName,
      page = _ref.page,
      cardProps = _ref.cardProps;
    var _ref2 = skywalkerCardData || {},
      headerData = _ref2.headerData,
      data = _ref2.data;
    var _ref3 = headerData || {},
      header = _ref3.header;
    var _ref4 = data || [],
      items = _ref4.items;
    var cardItems = (data == null ? void 0 : data.items) || [];
    var _useCardLoad = useCardLoad(),
      fireLoadEvent = _useCardLoad.fireLoadEvent;
    var _useAnalytics = useAnalytics();
      _useAnalytics.analyticsTrackAll;
      var adobe = _useAnalytics.adobe;
    useEffect(function () {
      pdtPush("recent_Search_card", {
        event_detail: {
          event_type: "load_event|other_click",
          event_value: "card-load"
        }
      });
    }, []);
    var handleCardClick = function handleCardClick(opts, index) {
      var _opts$ctaUrl = opts.ctaUrl,
        ctaUrl = _opts$ctaUrl === void 0 ? '' : _opts$ctaUrl;

      // analyticsTrackAll('growth_int_recent_search_card_click', {
      // 	lob: lobName,
      // 	item_position: index,
      // 	custom1: `page-${lobName}`,
      // });
      adobe.track('ctaClick', {
        cta: {
          name: "Recent Search_" + lobName,
          type: "dataClick | action:List_Item_Selected|position:h_" + index,
          destination: opts == null ? void 0 : opts.ctaUrl,
          componentName: cardSeq == null ? void 0 : cardSeq.id
        }
      });
      pdtPush("recent_Search_card", {
        event_detail: {
          event_type: "click_event|other_click",
          event_value: "card-click|" + lobName
        }
      });
      try {
        // let the lobs decide how to handle naviagation on click.
        if (cardProps != null && cardProps.onRecentSearchCardClick) {
          cardProps.onRecentSearchCardClick(opts);
        } else {
          /**
           *
           * NOTE: some lobs (flights) have seperate urls from mweb/dweb srp pages.
           * They send both the urls in meta.deeplink as stringify object.
           * Check if deeplink have mweb/dweb urls and redirect accordingly
           */
          var linkObj = safeParse(ctaUrl);
          if (linkObj != null && linkObj.dweb) {
            window.location.href = linkObj.dweb;
          } else {
            window.location.href = ctaUrl;
          }
        }
      } catch (e) {
        /* todo: log error in sentry */
      }
    };
    var handleCardLoad = function handleCardLoad() {
      fireLoadEvent("growth_non_int_rs-card-load-dweb-" + lobName + "-" + page);
    };
    return cardItems.length ? /*#__PURE__*/React.createElement(DwebHomeCardWrapper, {
      id: "rs-w01"
    }, /*#__PURE__*/React.createElement(DwebSectionCard, {
      id: "rs-w02"
    }, /*#__PURE__*/React.createElement(SearchHeader, null, header), /*#__PURE__*/React.createElement(NewCaraousel, {
      wrapperStyling: {
        padding: '0 0 22px 22px'
      },
      leftNavBtnStyle: {
        left: '-27px',
        top: '21%',
        height: '52px',
        width: '52px',
        padding: '0 2px'
      },
      rightNavBtnStyle: {
        right: '-27px',
        top: '21%',
        height: '52px',
        width: '52px',
        padding: '0 2px'
      },
      align: 0
    }, items.map(function (item, index) {
      return /*#__PURE__*/React.createElement(Card, {
        searchObj: item,
        key: item.ctaUrl,
        onClick: function onClick() {
          return handleCardClick(item, index);
        },
        onLoad: handleCardLoad
      });
    }), /*#__PURE__*/React.createElement(DwebRecentSearchAppCardBasic, {
      lobName: lobName,
      page: page
    })))) : null;
  };
  return RecentSearchDwebCardWithHOC;
};
var RecentSearchDwebRenderer = RecentSearchDwebRendererHOC(RecentSearchCardDweb);

export { RecentSearchDwebRenderer as R };
